import { Target, TrendingDown, Leaf, Sun, Wind } from "lucide-react";

const MODI_IMAGE = "/images/modi-portrait.jpg";

export default function IndiaCommitmentSection() {
  return (
    <section className="py-16 lg:py-24 bg-gradient-to-br from-orange-50 via-white to-green-50" data-testid="india-commitment-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="font-montserrat text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 mb-4">
            India's Climate Commitment
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            India is committed to becoming a global leader in climate action and sustainable development.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div className="flex justify-center">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-br from-orange-200 to-green-200 rounded-3xl blur-2xl opacity-30" />
              <div className="relative bg-white p-3 rounded-3xl shadow-lg">
                <img
                  src={MODI_IMAGE}
                  alt="Hon'ble Prime Minister Shri Narendra Modi"
                  className="w-full max-w-sm rounded-2xl object-cover aspect-[4/5]"
                  data-testid="india-image"
                />
                <p className="text-center text-sm text-slate-600 mt-3 font-medium">
                  Hon'ble PM Shri Narendra Modi — Leading India's Climate Vision
                </p>
              </div>
            </div>
          </div>

          {/* Commitments */}
          <div className="space-y-8">
            <div className="bg-white rounded-2xl p-6 shadow-sm border border-slate-100" data-testid="commitment-net-zero">
              <div className="flex items-start gap-4">
                <div className="p-3 bg-green-100 rounded-xl">
                  <Target className="h-6 w-6 text-green-700" />
                </div>
                <div>
                  <h3 className="font-montserrat text-xl font-semibold text-slate-900 mb-2">
                    Net Zero by 2070
                  </h3>
                  <p className="text-slate-600 leading-relaxed">
                    India has committed to achieving net-zero carbon emissions by 2070, 
                    demonstrating its dedication to combating climate change while ensuring 
                    sustainable economic growth.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-sm border border-slate-100" data-testid="commitment-intensity-reduction">
              <div className="flex items-start gap-4">
                <div className="p-3 bg-orange-100 rounded-xl">
                  <TrendingDown className="h-6 w-6 text-orange-700" />
                </div>
                <div>
                  <h3 className="font-montserrat text-xl font-semibold text-slate-900 mb-2">
                    45% Carbon Intensity Reduction by 2030
                  </h3>
                  <p className="text-slate-600 leading-relaxed">
                    India aims to reduce its carbon intensity (emissions per unit of GDP) by 45% 
                    by 2030, compared to 2005 levels, as part of its Nationally Determined 
                    Contributions under the Paris Agreement.
                  </p>
                </div>
              </div>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-4 pt-4">
              <div className="text-center p-4 bg-white/80 rounded-xl border border-slate-100">
                <div className="flex justify-center mb-2">
                  <Sun className="h-6 w-6 text-amber-500" />
                </div>
                <p className="text-2xl font-bold text-forest-950">500 GW</p>
                <p className="text-xs text-slate-600 mt-1">Renewable Energy Target (2030)</p>
              </div>
              <div className="text-center p-4 bg-white/80 rounded-xl border border-slate-100">
                <div className="flex justify-center mb-2">
                  <Wind className="h-6 w-6 text-sky-500" />
                </div>
                <p className="text-2xl font-bold text-earth-700">50%</p>
                <p className="text-xs text-slate-600 mt-1">Electricity from Renewables</p>
              </div>
              <div className="text-center p-4 bg-white/80 rounded-xl border border-slate-100">
                <div className="flex justify-center mb-2">
                  <Leaf className="h-6 w-6 text-emerald-500" />
                </div>
                <p className="text-2xl font-bold text-orange-600">1 Bn</p>
                <p className="text-xs text-slate-600 mt-1">Tonnes CO₂ Reduction</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
